import React from "react";
import { useNavigate } from "react-router-dom";
import service from "../Service/Servicesdata.json";

const MinemoServices = () => {
  const navigate = useNavigate();
  return (
    <div
      className="w-full py-10 sm:py-12 px-4 sm:px-8"
      style={{
        background: "#f5f0e8",
        fontFamily: "'Barlow', 'Montserrat', sans-serif",
      }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="text-xs font-bold tracking-[0.22em] text-gray-700 uppercase border-b-2 border-[#e8341c] pb-1">
            WHAT WE PROVIDE
          </span>
          <h2
            className="mt-4 text-gray-900 font-black uppercase"
            style={{
              fontSize: "clamp(28px, 4.5vw, 52px)",
              letterSpacing: "0.04em",
              fontFamily: "'Barlow Condensed', 'Oswald', sans-serif",
            }}
          >
            OUR KEY SERVICES
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10">
          {service?.map((item) => (
            <div
              key={item._id || item?.slug}
              onClick={() => navigate(`/services/${item?.slug}`)}
              className="flex flex-col group cursor-pointer"
            >
              {/* Image wrapper */}
              <div className="relative mb-4">
                {/* Orange shadow */}
                <div
                  className="absolute inset-0 rounded-xl -z-10 opacity-0 translate-x-0 translate-y-0 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-2 group-hover:translate-y-2"
                  style={{ background: "#e8341c" }}
                />

                {/* Image card */}
                <div className="relative rounded-xl overflow-hidden transition-all duration-300 group-hover:-translate-x-1 group-hover:-translate-y-1">
                  <img
                    src={item?.images?.[0] || "/placeholder.jpg"}
                    alt={item?.label || "service image"}
                    className="w-full h-56 object-cover"
                  />
                </div>
              </div>

              {/* Title */}
              <h3 className="font-extrabold text-gray-900 text-base mb-2 leading-snug">
                {item?.lable}
              </h3>

              {/* Description */}
              <p className="text-gray-500 text-sm leading-relaxed line-clamp-2">
                {item?.shortDescription}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MinemoServices;
